import React, { FunctionComponent, ReactNode } from 'react';
import { NumericBreakpoint } from 'app/constants/Breakpoints';
import { usePageBreakpoint } from 'app/components/layout/Breakpoint';
import { useClasses } from 'app/utils/css';

interface IProps {
  children: ReactNode;
}

const NavToolbar: FunctionComponent<IProps> = ({ children }) => {
  const breakpoint = usePageBreakpoint();
  const isNarrow = breakpoint <= NumericBreakpoint.Narrow;
  const isExtraNarrow = breakpoint <= NumericBreakpoint.ExtraNarrow;

  const padding = isNarrow ? '10px' : '16px';

  const classes = useClasses({
    toolbar: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'row',
      flexGrow: 1,
      boxSizing: 'border-box',
      minHeight: '40px',

      fontSize: isExtraNarrow ? '11px' : '12px',

      // Should be refactored to pass the padding into the first and last
      // children, and let them apply this padding them-selves instead
      // (as most elements are buttons, and their clickable and hoverable
      // area should be edge-to-edge).
      paddingLeft: padding,
      // handle link
      '> a:last-child': {
        paddingRight: padding,
      },
      // handle button
      '> button:last-child': {
        paddingRight: padding,
      },
      // handle NavDropdown
      '> span:last-child > button': {
        paddingRight: padding,
      },
    },
  });

  return <div className={classes.toolbar}>
    {children}
  </div>;
};

export const NavSpacer: FunctionComponent = () => {
  const classes = useClasses({
    spacer: {
      flex: 1,
    },
  });

  return <div className={classes.spacer} />;
};

export default NavToolbar;
